/* import __COLOCATED_TEMPLATE__ from './content-type-tab.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();